export default __webpack_public_path__ + "static/media/logout.51acb8a1.svg";